import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('rapid.SectionB');
    return (
        <div className={css.comp}>
            <div className="img-box">
                <EfImg
                    pc={'https://websiteoss.ecoflow.com/upload/image/1729599819868/pc_Tem.jpg'}
                    h5={'https://websiteoss.ecoflow.com/upload/image/1729599810728/m_Tem.jpg'}
                />
            </div>
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="number">
                    <span className="num">{t('text1')}</span>
                    <div className="mini">
                        <span className="green">{t('text2')}</span>
                        <span className="black">{t('text3')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
